export default __webpack_public_path__ + "static/IBMPlexSans-Light-Cyrillic-c3a84513ace37e633e6c98103061ff7b.woff";